// extracted by mini-css-extract-plugin
export default {"ResizeHandleInner":"ResizeHandle_ResizeHandleInner__9Fq88","ResizeHandleOuter":"ResizeHandle_ResizeHandleOuter__S395f","Icon":"ResizeHandle_Icon__eihP+"};